import React, { useState, useEffect, useRef } from 'react';
import { ref, onValue, set } from 'firebase/database';
import moment from 'moment';
import CryptoJS from 'crypto-js';
import 'animate.css'
import styled, { keyframes } from 'styled-components';

import { db } from './../config/Firebase';
import FlipperClock from './FlipperClock';
import HomeQr from './HomeQr';
import TournamentTable from './TournamentTable';
import SCORE_BG from './../assets/images/home/score_bg.png';
import TOSS_BG from './../assets/images/toss_bg.png';
import TOSS_GIF from './../assets/images/toss.gif';
import TIE_GIF from './../assets/images/match_tie.gif';
import SUPER_OVER from './../assets/images/super-over.gif';
import './css/Score.css';
import useQuery from './../hooks/useQuery';

const SECRET_KEY = 'qwertyuiopasdfghjklzxcvbnm';


const rotateX = keyframes`
   0% {
    transform: rotateY(0deg);
  }
  25% {
    transform: rotateY(20deg);
  }
  50% {
    transform: rotateY(0deg);
  }
  75% {
    transform: rotateY(-20deg);
  }
  100% {
    transform: rotateY(0deg);
  }
`;

const RotatingText = styled.div`
  display: inline-block;
  font-size: 24px;
  font-weight: bold;
  text-align: center;
  animation: ${rotateX} 5s infinite linear;
`;

function Score() {

    const batsmanRef = useRef([{ name: '', runs: '', balls: '', uuid: '' }, { name: '', runs: '', balls: '', uuid: '' }]);
    const bowlerRef = useRef({ name: '', over: '', runs: '', wicket: '' });
    const teamRef = useRef({ over: '', runs: '', teamA: '', teamB: '', innings: '' });
    const tournamentRef = useRef({ id: '', endTime: '', show: false });
    const gifRef = useRef({ show: false, val: '0', message: '' });
    const courtIdRef = useRef('');
    const boardIdRef = useRef('');
    const clearTimeRef = useRef();

    const [batsman, setBatsman] = useState(null);
    const [bowler, setBowler] = useState(null);
    const [team, setTeam] = useState(null);
    const [lastOver, setLastOver] = useState(null);
    const [gifObj, setGifObj] = useState(null);
    const [matchId, setMatchId] = useState(null);
    const [showScore, setScoreFlag] = useState(null);
    const [showClock, setClockFlag] = useState(null);
    const [boardEndTime, setBoardTime] = useState(null);
    const [undoArray, setUndoArray] = useState(null);
    const [showPlayer, setShowPlayer] = useState(null);
    const [tournamentDetails, setTournamentDetails] = useState(null);
    const [courtId, setCourtId] = useState(null);
    const [boardId, setBoardId] = useState(null);

    const query = useQuery();

    const cryptoDecryptText = (ct) => {
        const ciphertext = decodeURIComponent(ct);
        const bytes = CryptoJS.AES.decrypt(ciphertext, SECRET_KEY);
        const originalText = bytes.toString(CryptoJS.enc.Utf8);
        return originalText;
    };

    const updateActiveTime = () => {
        const courtRef = ref(db, '/boards/' + boardId);
        set(courtRef, moment().format('YYYY-MM-DD HH:mm:ss'))
            .then(() => { })
            .catch(() => { });
    };

    const decryptTextFun = () => {
        const paramValue = query.get('id');
        const ciphertext = cryptoDecryptText(paramValue);
        const textSplit = ciphertext.split(',');
        courtIdRef.current = textSplit[0];
        boardIdRef.current = textSplit[1];
        setCourtId(courtIdRef.current);
        setBoardId(boardIdRef.current);
    };


    const makeTeamName = (playerName) => {
        let newName = '';
        const nameSplit = playerName.trim().split(' ');
        if (nameSplit[0].length <= 4) {
            newName = nameSplit[0].trim().replace('*', '');
        } else {
            newName = nameSplit[0].slice(0, 4).trim().replace('*', '');
        }
        return newName + (playerName.trim().charAt(playerName.trim().length - 1) === '*' ? '*' : '');
    };

    const changeShowGifFlag = (val, message) => {
        if (clearTimeRef.current) {
            clearTimeout(clearTimeRef.current);
        }
        gifRef.current = { show: true, value: val, message };
        setGifObj(gifRef.current);
        clearTimeRef.current = setTimeout(() => {
            gifRef.current = { show: false, val: '0', message };
            setGifObj(gifRef.current);
        }, (val === 'win' || val === 'tie') ? 30000 : 8000);
    };

    const makeBowlerDetails = (currentArrayValue) => {
        const bowlerDetail = currentArrayValue.bowlerDetail ? currentArrayValue.bowlerDetail : currentArrayValue.newBowlerDetails;
        const bowlerSplit = bowlerDetail.split('&TFE&');
        const bowlerNameSplit = bowlerSplit[0].replace('*', '').trim().split(' ');
        bowlerRef.current = {
            name: bowlerNameSplit.length > 1 ? bowlerNameSplit[bowlerNameSplit.length - 1] : bowlerSplit[0].replace('*', '').trim(),
            over: bowlerSplit[1],
            runs: bowlerSplit[3],
            wickets: bowlerSplit[4]
        };
        setBowler(bowlerRef.current);
    };

    const makeBatsmanDetails = (currentArrayValue) => {
        if (currentArrayValue.type && currentArrayValue.type === 'retried out') {
            let wktPlayerInd = currentArrayValue.player1Details.includes(currentArrayValue.wicketPlayerId) ? 0 : 1;
            batsmanRef.current[wktPlayerInd] = {
                name: '',
                runs: '',
                balls: '',
                uuid: ''
            };
        } else if (currentArrayValue.actionType === 'newBatsmanUpdate') {
            const playerSplit = currentArrayValue.newBatsman.split('&TFE&');
            const playerNameSplit = playerSplit[0].replace(' *', '*').trim().split(' ');
            let ind = batsmanRef.current[0].name ? 1 : 0;
            if (playerSplit.includes('null')) {
                batsmanRef.current[ind] = { name: '', runs: '', balls: '', uuid: '' };
            } else {
                batsmanRef.current[ind] = {
                    name: playerNameSplit.length > 1 ? playerNameSplit[playerNameSplit.length - 1] : playerSplit[0].trim(),
                    runs: playerSplit[1],
                    balls: playerSplit[2],
                    uuid: playerSplit[6]
                };
            };
        } else {
            const player1Split = currentArrayValue.player1Details.split('&TFE&');
            const player2Split = currentArrayValue.player2Details.split('&TFE&');
            const player1NameSplit = player1Split[0].replace(' *', '*').trim().split(' ');
            const player2NameSplit = player2Split[0].replace(' *', '*').trim().split(' ');
            batsmanRef.current = [{
                name: player1NameSplit.length > 1 ? player1NameSplit[player1NameSplit.length - 1] : player1Split[0].trim(),
                runs: player1Split[1],
                balls: player1Split[2],
                uuid: player1Split[6],
                wicket: 0
            }, {
                name: player2NameSplit.length > 1 ? player2NameSplit[player2NameSplit.length - 1] : player2Split[0].trim(),
                runs: player2Split[1],
                balls: player2Split[2],
                uuid: player2Split[6],
                wicket: 0
            }];
            if (currentArrayValue.type === 'wicket') {
                let findInd = batsmanRef.current.findIndex(x => x.uuid === currentArrayValue.wicketPlayerId);
                batsmanRef.current[findInd] = { name: '', runs: '', balls: '', uuid: '' };
            }
        }

        setBatsman(batsmanRef.current);
    };

    const makeTeamDetails = (currentArrayValue) => {
        const teamScoreSplit = currentArrayValue.teamDetail.split('&TFE&');
        const teamSplit = currentArrayValue.teamName.split('&TFE&');
        const teamASplit = teamSplit[0].trim().split(' ');
        const teamBSplit = teamSplit[1].trim().split(' ');
        const inningSplit = currentArrayValue.inningsDetail.split('&TFE&');
        teamRef.current = {
            over: teamScoreSplit[2],
            runs: teamScoreSplit[1],
            innings: teamScoreSplit[0],
            teamA: teamASplit.length > 1 ? teamSplit[0].trim().match(/\b(\w)/g).join('').toUpperCase() : teamSplit[0].trim().toUpperCase(),
            teamB: teamBSplit.length > 1 ? teamSplit[1].trim().match(/\b(\w)/g).join('').toUpperCase() : teamSplit[1].trim().toUpperCase(),
            inningScore: inningSplit[1],
            inningBall: inningSplit[2]
        };
        setTeam(teamRef.current);
    };

    const makeOverDetails = (scoreArray) => {
        let currentArrayValue = {};
        for (let ballInd = scoreArray.length - 1; ballInd >= 0; ballInd--) {
            if (scoreArray[ballInd].apiRefresh && (scoreArray[ballInd].actionType === 'inningsComplete' || scoreArray[ballInd].actionType === 'inningsStart' || scoreArray[ballInd].actionType === 'matchTie'
                || (scoreArray[ballInd].isOverCompleted && scoreArray[ballInd].actionType === 'newBowlerUpdate'))) {
                currentArrayValue = { ball: '0', teamUuid: '' };
                break;
            } else if (scoreArray[ballInd].ball) {
                currentArrayValue = scoreArray[ballInd];
                break;
            }
        }
        let currentOver = parseInt(currentArrayValue.ball);
        let currentTeam = currentArrayValue.teamUuid;
        let balls = [];
        for (let ballInd = scoreArray.length - 1; ballInd >= 0; ballInd--) {
            if (currentTeam === scoreArray[ballInd].teamUuid) {
                if ((scoreArray[ballInd].ball && currentOver !== parseInt(scoreArray[ballInd].ball))) {
                    break;
                } else if (scoreArray[ballInd].ball && currentOver === parseInt(scoreArray[ballInd].ball)) {
                    let currentBallRun = scoreArray[ballInd].powerPlay ? (parseInt(scoreArray[ballInd].run) / 2) : scoreArray[ballInd].run;
                    if (scoreArray[ballInd].type === 'wicket') {
                        currentBallRun = 'W';
                    } else if (scoreArray[ballInd].type === 'noball' || scoreArray[ballInd].type === 'no ball') {
                        currentBallRun += 'NB';
                    } else if (scoreArray[ballInd].type === 'wide') {
                        currentBallRun += 'WD';
                    } else if (scoreArray[ballInd].type === 'legbye' || scoreArray[ballInd].type === 'leg byes') {
                        currentBallRun += 'LB';
                    } else if (scoreArray[ballInd].type === 'bye' || scoreArray[ballInd].type === 'byes') {
                        currentBallRun += 'B';
                    } else if (scoreArray[ballInd].type === 'retried out') {
                        currentBallRun = 'RH';
                    }
                    balls.push({ run: currentBallRun, type: scoreArray[ballInd].type });
                }
            } else if ((scoreArray[ballInd].isOverCompleted && scoreArray[ballInd].actionType === 'newBowlerUpdate') || (scoreArray[ballInd].actionType === 'inningsComplete' || scoreArray[ballInd].actionType === 'inningsStart' || scoreArray[ballInd].actionType === 'matchTie')) {
                break;
            }
        }
        balls = balls.reverse();
        if (balls.length < 6) {
            for (let ballInd = balls.length; ballInd < 6; ballInd++) {
                balls.push({ run: '' });
            }
        }
        setLastOver(balls.length > 7 ? balls.slice(balls.length - 7, balls.length) : balls);
    };

    const makeScoreBoard = (actualData) => {
        if (actualData) {
            const data = {};
            for (const dataKey in actualData) {
                if (actualData[dataKey] && ((actualData[dataKey].actionType && actualData[dataKey].actionType !== 'matchInitiate') || actualData[dataKey].ball)) {
                    data[dataKey] = actualData[dataKey];
                }
            }
            const scoreArray = Object.values(data);
            const scoreKeys = Object.keys(data);

            const currentArrayValue = scoreArray[scoreArray.length - 1];
            const currentKeyValue = scoreKeys[scoreKeys.length - 1];
            if (scoreArray.length) {
                makeOverDetails(scoreArray);
                if (!currentArrayValue.apiRefresh) {
                    makeBatsmanDetails(currentArrayValue);
                    makeBowlerDetails(currentArrayValue);
                    makeTeamDetails(currentArrayValue);
                    let cpyUnodArray = undoArray;
                    let findInd = undoArray.findIndex(x => x === currentKeyValue);
                    cpyUnodArray = cpyUnodArray.push(currentKeyValue);
                    if (findInd < 0) {
                        if (currentArrayValue.type === '4' || currentArrayValue.type === '6' || currentArrayValue.type === 'wicket') {
                            changeShowGifFlag(currentArrayValue.type);
                        }
                        setUndoArray(cpyUnodArray);
                    }
                } else if (currentArrayValue.apiRefresh && currentArrayValue.actionType) {
                    let cpyUnodArray = undoArray;
                    let findInd = undoArray.findIndex(x => x === currentKeyValue);
                    cpyUnodArray = cpyUnodArray.push(currentKeyValue);
                    console.log('findInd=', findInd);
                    if (findInd <= 0) {
                        if (currentArrayValue.actionType === 'toss') {
                            if (clearTimeRef.current) {
                                clearTimeout(clearTimeRef.current);
                            }
                            gifRef.current = { show: true, value: 'toss-gif', message: currentArrayValue.tossWonDetails };
                            setGifObj(gifRef.current);
                            clearTimeRef.current = setTimeout(() => {
                                gifRef.current = { show: true, value: 'toss', message: currentArrayValue.tossWonDetails };
                                setGifObj(gifRef.current);
                            }, 2500)
                        } else if (currentArrayValue.actionType === 'inningsStart') {
                            if (clearTimeRef.current) {
                                clearTimeout(clearTimeRef.current);
                            }
                            makeBowlerDetails(currentArrayValue);
                            gifRef.current = { show: false, value: 0, message: '' };
                            setGifObj(gifRef.current);
                            makeBatsmanDetails(currentArrayValue);
                            const teamScoreSplit = currentArrayValue.teamDetail.split('&TFE&');
                            const teamASplit = teamScoreSplit[0].trim().split(' ');
                            const teamBSplit = teamScoreSplit[1].trim().split(' ');
                            teamRef.current = {
                                over: '0.0',
                                runs: '0/0',
                                innings: teamScoreSplit[2],
                                teamA: teamASplit.length > 1 ? teamScoreSplit[0].trim().match(/\b(\w)/g).join('').toUpperCase() : teamScoreSplit[0].trim(),
                                teamB: teamBSplit.length > 1 ? teamScoreSplit[1].trim().match(/\b(\w)/g).join('').toUpperCase() : teamScoreSplit[1].trim()
                            };
                            if (teamScoreSplit[2] === '2nd') {
                                const inningSplit = currentArrayValue.inningsDetail.split('&TFE&');
                                teamRef.current.inningScore = inningSplit[1] ? inningSplit[1] : 0;
                                teamRef.current.inningBall = inningSplit[2];
                            }
                            setTeam(teamRef.current);
                        } else if (currentArrayValue.actionType === 'newBatsmanUpdate') {
                            makeBatsmanDetails(currentArrayValue);
                        } else if (currentArrayValue.actionType === 'newBowlerUpdate') {
                            makeBowlerDetails(currentArrayValue);
                        } else if (currentArrayValue.actionType === 'matchTie') {
                            if (currentArrayValue.isSuperOver) {
                                if (clearTimeRef.current) {
                                    clearTimeout(clearTimeRef.current);
                                }
                                gifRef.current = { show: true, value: 'super-over' };
                                setGifObj(gifRef.current);
                            }
                        } else if (currentArrayValue.actionType === 'inningsComplete') {
                            const teamDetailSplit = currentArrayValue.teamDetail.split('&TFE&');
                            let message = '';
                            if (clearTimeRef.current) {
                                clearTimeout(clearTimeRef.current);
                            }
                            if (teamDetailSplit[2] === '1st') {
                                message = `
                                    Innings Break \n
                                    ${teamDetailSplit[1].trim()} need ${teamDetailSplit[3]} runs from ${teamDetailSplit[4]}  balls
                                `;
                                gifRef.current = { show: true, value: 'break', message };
                                setGifObj(gifRef.current);
                            } else {
                                if (currentArrayValue.wonDetails.endsWith('tie')) {
                                    message = currentArrayValue.wonDetails;
                                    changeShowGifFlag('tie', message);
                                } else {
                                    message = `
                                        Congratulations \n
                                        ${currentArrayValue.wonDetails}`;
                                    changeShowGifFlag('win', message);
                                }
                            }
                        }
                        setUndoArray(cpyUnodArray);
                    }
                }
            }
        } else {
            batsmanRef.current = [{ name: '', runs: '', balls: '', uuid: '', wicket: 0 }, { name: '', runs: '', balls: '', uuid: '', wicket: 0 }];
            setBatsman(batsmanRef.current);
        }
    };

    useEffect(() => {
        if (showScore && matchId) {
            const matchRef = ref(db, '/matches/' + matchId);
            onValue(matchRef, (snapshot) => {
                const data = snapshot.val();
                console.info('MATCH DATA=', data);
                makeScoreBoard(data);
            }, {
                onlyOnce: false
            });
        }
    }, [showScore, matchId]);

    useEffect(() => {
        if (courtId && boardId) {
            const courtRef = ref(db, '/courts/' + courtId);
            onValue(courtRef, (snapshot) => {
                const data = snapshot.val();
                console.log('COURT DATA=', data);
                const currentTime = moment().format('YYYY-MM-DD HH:mm:ss');
                if (data && parseInt(data.startScore) === 1 && moment(data.boardEndTime).isAfter(currentTime)) {
                    setClockFlag(moment(data.boardEndTime).isAfter(currentTime) ? true : false);
                    if (data.tournamentId && moment(data.tournamentEndTime).isAfter(currentTime)) {
                        tournamentRef.current = {
                            id: data.tournamentId,
                            endTime: data.tournamentEndTime,
                            show: true
                        };
                        setTournamentDetails(tournamentRef.current);
                    } else {
                        tournamentRef.current = { id: '', endTime: '', show: false };
                        setTournamentDetails(tournamentRef.current);
                    }
                    setBoardTime(data.boardEndTime);
                    setMatchId(data.matchId);
                    setScoreFlag(true);
                } else {
                    setMatchId('');
                    setScoreFlag(false);
                    setBoardTime(currentTime);
                    tournamentRef.current = { id: '', endTime: '', show: false };
                    setTournamentDetails(tournamentRef.current);
                    setClockFlag(false);
                    gifRef.current = { show: false, val: '0', message: '' };
                    setGifObj(gifRef);
                }
                setUndoArray([]);
            }, {
                onlyOnce: false
            });

            const interval = setInterval(() => {
                updateActiveTime();
            }, 150000);

            return () => clearInterval(interval);
        }
    }, [courtId, boardId]);

    useEffect(() => {
        const interval = setInterval(() => {
            const currentTime = moment().format('YYYY-MM-DD HH:mm:ss');
            if (tournamentRef.current.endTime && moment(tournamentRef.current.endTime).isAfter(currentTime)) {
                tournamentRef.current.show = true;
                setTournamentDetails(tournamentRef.current);
            } else {
                tournamentRef.current = { id: '', endTime: '', show: false };
                setTournamentDetails(tournamentRef.current);
            }
        }, 20000);
        return () => clearInterval(interval);
    }, [tournamentDetails]);

    useEffect(() => {
        setBatsman(batsmanRef.current);
        setBowler(bowlerRef.current);
        setTeam(teamRef.current);
        setCourtId(courtIdRef.current);
        setBoardId(boardIdRef.current);
        setLastOver([{ run: '' }, { run: '' }, { run: '' }, { run: '' }, { run: '' }, { run: '' }]);
        setGifObj(gifRef.current);
        setMatchId('');
        setScoreFlag(false);
        setClockFlag(false);
        setBoardTime(moment().format('YYYY-MM-DD HH:mm:ss'));
        setUndoArray([]);
        setTournamentDetails(tournamentRef.current);

        decryptTextFun();
    }, []);

    useEffect(() => {
        const interval = setInterval(() => {
            setShowPlayer((prevIndex) => (prevIndex === 1 ? 2 : 1));
        }, 5000);
        return () => clearInterval(interval);
    }, []);

    return (
        <>
            {
                boardId && courtId ? showScore && gifRef.current && gifRef.current.show ?
                    (
                        gifRef.current.value === '4' ? (<img src={process.env.PUBLIC_URL + '/images/four.gif'} alt="Four gif" width="320" height="240" />)
                            : gifRef.current.value === '6' ? (<img src={process.env.PUBLIC_URL + '/images/six.gif'} alt="Six gif" width="320" height="240" />)
                                : gifRef.current.value === 'wicket' ? (<img src={process.env.PUBLIC_URL + '/images/wicket.gif'} alt="Wicket gif" width="320" height="240" />)
                                    : gifRef.current.value === 'win' ? (
                                        <div className="container">
                                            <img src={process.env.PUBLIC_URL + '/images/win.gif'} alt="Win gif" width="320" height="240" />
                                            <div className="centered">
                                                {gifRef.current.message.split('\n').map((line, index) => (
                                                    <RotatingText style={{ fontSize: '30px', fontWeight: 800, fontFamily: 'Arial, sans-serif' }} key={index}>{line}</RotatingText>
                                                ))}
                                            </div>
                                        </div>
                                    ) : gifRef.current.value === 'toss-gif' ? (
                                        <div className="container">
                                            <img src={TOSS_GIF} alt="Toss gif" width="320" height="240" />
                                        </div>
                                    ) : gifRef.current.value === 'super-over' ? (
                                        <div className="container">
                                            <img src={SUPER_OVER} alt="Super over gif" width="320" height="240" />
                                        </div>
                                    ) : gifRef.current.value === 'toss' ? (
                                        <div className="container">
                                            <img src={TOSS_BG} alt="Toss gif" width="320" height="240" />
                                            <div className="centered" >
                                                {
                                                    gifRef.current.message.split('\n').map((line, index) => (
                                                        <h2 className="animate__animated animate__flipInY" style={{ fontSize: '10vw', fontWeight: 800, color: "#fff", fontFamily: 'Arial, sans-serif' }} key={index}>{line}</h2>
                                                    ))
                                                }
                                            </div>
                                        </div >
                                    ) : gifRef.current.value === 'break' ? (
                                        <div className="container" style={{ backgroundColor: '#3700d2' }}>
                                            <img src={SCORE_BG} alt="Break bg" width="320" height="240" />
                                            <div className="centered" >
                                                {
                                                    gifRef.current.message.split('\n').map((line, index) => (
                                                        <h2 className="animate__animated animate__pulse animate__slow animate__infinite" style={{ fontSize: '10vw', fontWeight: 750, color: '#fff', fontFamily: 'Arial, sans-serif' }} key={index}>{line}</h2>
                                                    ))
                                                }
                                            </div>
                                        </div >
                                    ) : gifRef.current.value === 'tie' ? (
                                        <div className="container" style={{ backgroundColor: '#3700d2' }}>
                                            <img src={TIE_GIF} alt="Tie bg" width="320" height="240" />
                                        </div >
                                    ) : (
                                        <div className="container" style={{ backgroundColor: '#3700d2' }}>
                                            <img src={SCORE_BG} alt="Win gif" width="320" height="240" />
                                            <div className="centered">
                                                {gifRef.current.message.split('\n').map((line, index) => (
                                                    <h2 style={{ fontSize: '30px', fontWeight: 800 }} key={index}>{line}</h2>
                                                ))}
                                            </div>
                                        </div>
                                    )
                    )
                    : showScore && matchId && (batsman[0].name || batsman[1].name) ? (
                        <div className="score-div">
                            <table>
                                <tbody id="scoreboard-body">
                                    <tr >
                                        <th style={{ width: '160px' }} className="score-div-column">
                                            <FlipperClock boardEndTime={boardEndTime} setScoreFlag={setScoreFlag} setClockFlag={setClockFlag} />
                                        </th>
                                        <th className="score-div-column" style={{ fontSize: '7.5vw' }}>{team.teamA.substring(0, 3)} vs {team.teamB.substring(0, 3)}</th>
                                    </tr>
                                    <tr>
                                        <td className="score-div-column" colSpan={2} style={{ padding: '0px' }}>
                                            <div style={{ flexDirection: 'row', display: 'flex', justifyContent: 'center' }}>
                                                <h1 style={{ fontSize: '11vw', marginTop: '2px' }}>{team.teamA.substring(0, 5)}</h1>
                                                <h6 style={{ fontSize: '40px' }}>&nbsp;&nbsp;{team.runs}</h6>
                                                <h6 style={{ fontSize: '35px', marginTop: '3px' }}>&nbsp;&nbsp;{team.over}</h6>
                                            </div>
                                        </td>
                                    </tr>
                                    {
                                        showPlayer === 1 ? (
                                            <tr style={{ width: '240px' }}>
                                                <td className="score-div-column" style={{ fontSize: '25px', fontWeight: 600, padding: '0px', justifyContent: 'center' }}>
                                                    {
                                                        batsman[0].name && batsman[0].uuid !== 'dummy_player_001' ? (<>{makeTeamName(batsman[0].name)}&nbsp;{batsman[0].runs}({batsman[0].balls})</>) : (<></>)
                                                    }
                                                </td>
                                                <td className="score-div-column" style={{ fontSize: '25px', fontWeight: 600, padding: '0px', justifyContent: 'center' }}>
                                                    {
                                                        batsman[1].name && batsman[1].uuid !== 'dummy_player_001' ? (<>{makeTeamName(batsman[1].name)}&nbsp;{batsman[1].runs}({batsman[1].balls})</>) : (<></>)
                                                    }
                                                </td>
                                            </tr>
                                        ) : (
                                            <tr>
                                                <td className="score-div-column" colSpan={2} style={{ padding: '0px' }}>
                                                    <div style={{ flexDirection: 'row', display: 'flex', padding: '0px', justifyContent: 'center' }}>
                                                        <h1 style={{ fontSize: '25px', fontWeight: 600 }}>{bowler.name}</h1>&nbsp;&nbsp;&nbsp;
                                                        <h1 style={{ fontSize: '25px', fontWeight: 600 }}>{bowler.wickets} - </h1>
                                                        <h6 style={{ fontSize: '25px', fontWeight: 600 }}>&nbsp;{bowler.runs}</h6>
                                                        <h6 style={{ fontSize: '25px', fontWeight: 600 }}>&nbsp;({bowler.over})</h6>
                                                    </div>
                                                </td>
                                            </tr>
                                        )
                                    }
                                    <tr>
                                        <td className="score-div-column" colSpan={2}>
                                            <div style={{ display: "flex", justifyContent: 'center', padding: '5px 0px' }}>
                                                {
                                                    lastOver.map((ball, ind) => {
                                                        return (
                                                            <div key={ind} className="round-border"><span style={{ fontSize: (ball.run.length === 1 ? "23px" : ball.run.length === 2 ? "19px" : "15px"), fontWeight: "600" }}>{ball.run}</span></div>
                                                        )
                                                    })
                                                }
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="score-div-column" colSpan={2}>
                                            <div style={{ display: "flex", alignItems: "center", justifyContent: 'center', padding: '5px 0px' }}>
                                                <h1 style={{ fontSize: '24px', fontWeight: 700 }}>
                                                    {team.innings === '2nd' ? (<>Need {team.inningScore < 0 ? 0 : team.inningScore} runs from {team.inningBall} balls</>) : (<>1st Innings</>)}
                                                </h1>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    )
                        : showScore && tournamentDetails && tournamentDetails.show ? (
                            <TournamentTable
                                tournamentDetails={tournamentDetails}
                                gifObj={gifObj}
                                boardEndTime={boardEndTime}
                                setScoreFlag={setScoreFlag}
                                setClockFlag={setClockFlag}
                            />
                        ) : (
                            <HomeQr
                                boardEndTime={boardEndTime}
                                setClockFlag={setClockFlag}
                                boardId={boardId}
                                showClock={showClock}
                                setScoreFlag={setScoreFlag}
                            />)
                    : (<></>)

            }
        </>
    );
}

export default Score;
